<script>  
//liblary
  import axios from "axios";

  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
    import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  
  export let size = 6;
  export let action; 
  export let id = "";
  export let rating=0;
  let uidcont = Math.random().toString(36).substring(2);
  let uid = Math.random().toString(36).substring(2);
 
   rating = parseInt(rating);
  if(rating>0){
    setTimeout(() => {
    onHover((rating+1)); 
    clearRange();
  }, 500); 
  }

  function onLeave(){  
    if(document.getElementsByClassName("range-"+uidcont)){ 
      Array.from(document.getElementsByClassName("range-"+uidcont)).forEach((el) => {
        el.classList.remove("bg-yellow-500");
      });
    }
  }
  function onHover(range){  
    if(document.getElementsByClassName("range-"+uidcont)){
      Array.from(document.getElementsByClassName("range-"+uidcont)).forEach((el) => {
        el.classList.add("bg-yellow-500");
      });

      Array.from(document.getElementsByClassName("notrange-"+uidcont+"-"+range)).forEach((el) => {
        el.classList.add("bg-yellow-500");
      });
      
      Array.from(document.getElementsByClassName("range-"+uidcont+"-"+range)).forEach((el) => {
        el.classList.remove("bg-yellow-500");
      });
    }
  }
  
  function clearRange(){
    Array.from(document.getElementsByClassName("ranges-"+uidcont)).forEach((el) => {
      el.classList.remove("range-"+uidcont);
      el.classList.remove("range-"+uidcont+"-1");
      el.classList.remove("range-"+uidcont+"-2");
      el.classList.remove("range-"+uidcont+"-3");
      el.classList.remove("range-"+uidcont+"-4");
      el.classList.remove("range-"+uidcont+"-5"); 
      el.classList.remove("notrange-"+uidcont+"-1");
      el.classList.remove("notrange-"+uidcont+"-2");
      el.classList.remove("notrange-"+uidcont+"-3");
      el.classList.remove("notrange-"+uidcont+"-4");
      el.classList.remove("notrange-"+uidcont+"-5");
      el.classList.remove("notrange-"+uidcont+"-6"); 
    });
  }
  function onClick(range){    
    if(action){
    axios
      .post(
        settings.url + "/"+action+"?authorization=" + settings.token,
        {
          transactionID: id,
          rating: range
        }
      )
      .then(function (response) {
        clearRange();
      })
      .catch(function (error) {
        
        if (error.response.status == 401) {
          localStorage.removeItem("t"); 
        }
      });
      }
  }
</script> 
<div class="flex items-center" on:mouseleave={()=>onLeave()}>
  <span class="cursor-pointer h-{size} w-{size} rounded-full p-1 mx-1 ranges-{uidcont} range-{uidcont} range-{uidcont}-1 notrange-{uidcont}-2" on:mouseover={()=>onHover(2)} on:click={()=>onClick(1)}>
    <svg id="icon-star-{uid}" viewBox="0 0 32 32"><title>1 bintang</title>
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8
                            7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" /></svg>
  </span>
  <span class="cursor-pointer h-{size} w-{size} rounded-full p-1 mx-1 ranges-{uidcont} range-{uidcont} range-{uidcont}-1 range-{uidcont}-2 notrange-{uidcont}-3" on:mouseover={()=>onHover(3)} on:click={()=>onClick(2)}>
    <svg id="icon-star-{uid}" viewBox="0 0 32 32"><title>2 bintang</title>
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8
                            7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" /></svg>
  </span>
  <span class="cursor-pointer h-{size} w-{size} rounded-full p-1 mx-1 ranges-{uidcont} range-{uidcont} range-{uidcont}-1 range-{uidcont}-2 range-{uidcont}-3 notrange-{uidcont}-4" on:mouseover={()=>onHover(4)} on:click={()=>onClick(3)}>
    <svg id="icon-star-{uid}" viewBox="0 0 32 32"><title>3 bintang</title>
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8
                            7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" /></svg>
  </span>
  <span class="cursor-pointer h-{size} w-{size} rounded-full p-1 mx-1 ranges-{uidcont} range-{uidcont} range-{uidcont}-1 range-{uidcont}-2 range-{uidcont}-3 range-{uidcont}-4 notrange-{uidcont}-5" on:mouseover={()=>onHover(5)} on:click={()=>onClick(4)}>
    <svg id="icon-star-{uid}" viewBox="0 0 32 32"><title>4 bintang</title>
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8
                            7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" /></svg>
  </span>
  <span class="cursor-pointer h-{size} w-{size} rounded-full p-1 mx-1 ranges-{uidcont} range-{uidcont} range-{uidcont}-1 range-{uidcont}-2 range-{uidcont}-3 range-{uidcont}-4 range-{uidcont}-5 notrange-{uidcont}-6" on:mouseover={()=>onHover(6)} on:click={()=>onClick(5)}>
    <svg id="icon-star-{uid}" viewBox="0 0 32 32"><title>5 bintang</title>
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8
                            7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" /></svg>
  </span>
</div>
